import { Text } from "@src/shared/components/general/Text";
import { VerticalFlexbox } from "@src/shared/components/layout/Flexbox";
import { Button } from "@src/shared/components/ui/button";
import { Spinner } from "@src/shared/components/ui/spinner";

import styles from "./LoginIframe.module.less";

export interface LoginIframePageProps {
  isLoading?: boolean;
  error?: string | null;
  onRetry?: () => void;
}

export const LoginIframePage = ({
  isLoading,
  error,
  onRetry,
}: LoginIframePageProps) => {
  return (
    <VerticalFlexbox className={styles.wrapper}>
      <VerticalFlexbox className={styles.content}>
        {isLoading && (
          <VerticalFlexbox className={styles.loadingContainer}>
            <Text>Logging in…</Text>
            <Spinner size="lg" />
          </VerticalFlexbox>
        )}
        {error && !isLoading && (
          <VerticalFlexbox className={styles.errorContainer}>
            <div className={styles.errorIcon} aria-hidden>
              !
            </div>
            <Text className={styles.errorTitle}>Something went wrong</Text>
            <Text className={styles.errorDescription}>{error}</Text>
            {onRetry && (
              <Button
                className={styles.retryButton}
                onClick={onRetry}
                type="button"
              >
                Refresh
              </Button>
            )}
          </VerticalFlexbox>
        )}
      </VerticalFlexbox>
    </VerticalFlexbox>
  );
};
